import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class UniqueIndex extends CloudObject {
    /**
     * Creates an instance of UniqueIndex.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(UniqueIndex);
    }

    /**
     * @return {string}
     */
    getTableName() {
        return this.get(UniqueIndex.tableNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeTableName($) {
        return this.observe($, UniqueIndex.tableNameProp);
    }

    /**
     * @return {string}
     */
    getColumnName() {
        return this.get(UniqueIndex.columnNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeColumnName($) {
        return this.observe($, UniqueIndex.columnNameProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setTableName(transaction, instance, value) {
        transaction.update(instance, UniqueIndex.tableNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setColumnName(transaction, instance, value) {
        transaction.update(instance, UniqueIndex.columnNameProp, value);
    }
}

// Hardcoded tags
register('0190ede414dca5cf2ed5', UniqueIndex);
UniqueIndex.tableNameProp = defineProperty('0190ede46c98c0507414');
UniqueIndex.columnNameProp = defineProperty('0190ede451ee168e5c5c');
